export const BOOLEAN_LITERAL_REGEX = /^(true|false)$/
